// extracted by mini-css-extract-plugin
module.exports = {"aboutPanel":"aboutPanel_aboutPanel__1jDk8","summary":"aboutPanel_summary__1DDHD","content":"aboutPanel_content__mkjuY","noSidebar":"aboutPanel_noSidebar__2hCmw"};